import { ROLES__SELF__REQUESTED__SUCCEEDED, DROPBOXES__ROLES__REQUESTED__SUCCEEDED } from "../constants/actionTypes";

import _ from 'lodash';

const INITIAL_STATE = {},
    id = iteratee => {
        return iteratee.id;
    }
;

export function roles(state = INITIAL_STATE, action) {
    switch (action.type) {

        case DROPBOXES__ROLES__REQUESTED__SUCCEEDED: {
            const { dropbox_roles } = action.payload;

            return _.mapKeys(dropbox_roles.entities, id);
        }

        default:
            return state;
    }
}

export function roles_self(state = INITIAL_STATE, action) {
    switch (action.type) {

        case ROLES__SELF__REQUESTED__SUCCEEDED: {
            const { dropbox_roles } = action.payload;

            return _.mapKeys(dropbox_roles.entities, id);
        }

        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/rolesReducer.js
 **/